import './page.scss'

import {FunctionComponent, wrap} from '@codeurs/front'
import React from 'react'
import {style} from 'util/campagne/style'
import {Layout} from 'views/campagne/layout'
import Blocks from 'views/campagne/partials/blocks'
import {Theme} from 'views/campagne/theme'

const styles = style('page')

export const Page: FunctionComponent = wrap(Layout)(({blocks}) => (
	<div class={styles}>
		<Theme.Container>
			<div class={styles('content')}>
				<Blocks blocks={blocks} />
			</div>
		</Theme.Container>
	</div>
))
